import React from 'react'

const Alphabet_pattern = () => {
    return (
        <div className='container'>
            <h1>Print Alphabet Pattern in Python</h1>
            <div className='containers'>
                <pre>{`A
A B
A B C
A B C D
A B C D E`}</pre>

            </div>
            <h3>Code</h3>
            <div className='containers'>
                <code className='keywords'> for</code> i in <code className='keywords'>range</code>(65, 70): <br />
           &nbsp;    <code className='keywords'>  for </code>j in <code className='keywords'>range</code>(65, i+1): <br />
           &nbsp;   <code className='keywords'></code> <br />
           &nbsp;    &nbsp; <code className='library'>   print </code>(chr(j),end="") <br />
           &nbsp; <code className='library'>print()</code> <br />
            </div>
            <h2>Right-angled pattern with characters</h2>
            <div className='containers'>
                <pre>{`A 
B C 
D E F 
G H I J 
K L M N O`} </pre></div>
            <h3>code</h3>
            <div className='containers'>
                <code className='library'>print</code>("The character pattern ")   <br />
asciiValue = 65    <code className='comment'> #ASCII value of A  </code> <br />
                <code className='keywords'>for</code> i in<code className='keywords'> range</code>(0, 5): <br />
&nbsp;&nbsp;<code className='keywords'>  for</code> j in <code className='keywords'> range</code>(0, i + 1):   <br />
&nbsp;&nbsp;&nbsp;<code className='comment'>  # It will convert the ASCII value to the character  </code> <br />
&nbsp;&nbsp;&nbsp;   alphabate = chr(asciiValue)   <br />
&nbsp;&nbsp;&nbsp;   <code className='library'>   print</code>(alphabate, end=' ')   <br />
&nbsp;&nbsp;&nbsp;  asciiValue += 1   <br />
&nbsp;&nbsp;  <code className='library'> print() </code> </div> <br />
            <h3>Equilateral triangle pattern with characters</h3>
            <div className='containers'>
                <pre> {`  
        A 
       B C 
      D E F 
     G H I J 
    K L M N O`} </pre>

            </div>
            <div className='containers'>
                <code className='library'> print</code>("Print equilateral triangle Pyramid with characters ")  <br />
s = 5  <br />
                <br />
asciiValue = 65  <br />
m = (2 * s) - 2  <br />
                <code className='keywords'>for </code>i in<code className='keywords'> range</code>(0, s):  <br />
                <code className='keywords'> &nbsp;  for </code> j in<code className='keywords'> range</code>(0, m):  <br />
                <code className='library'>&nbsp; &nbsp;  print</code>(end=" ")  <br />
                <code className='comment'> # Decreased the value of after each iteration  </code><br />
&nbsp;  m = m - 1  <br />
                <code className='keywords'> &nbsp; for</code> j in <code className='keywords'>range</code>(0, i + 1):  <br />
    &nbsp; &nbsp; &nbsp; alphabate = chr(asciiValue)  <br />
                <code className='library'>&nbsp;  print</code>(alphabate, end=' ')  <br />
                <code className='comment'> # Increase the ASCII number after each iteration  </code><br />
        &nbsp; &nbsp;  asciiValue += 1  <br />
                <code className='keywords'>&nbsp;  print</code>()  <br />
            </div>
            <h3>Display letter of the word in Pattern</h3>
            <div className='containers'>
                <pre> {`  
N
No
Noo
NooB
NooBG
NooBGe
NooBGee
NooBGeek
NooBGeeks`} </pre>

            </div>
            <div className='containers'>
                <code className='keywords'> str1 </code>= "NooBGeeks"  <br />
x = ""  <br />
                <code className='keywords'>for</code> i in <code className='keywords'>str1: </code> <br />
&nbsp; x += i  <br />
                <code className='library'>&nbsp;  print</code> (x)  <br />
            </div>
        </div>
    )
}

export default Alphabet_pattern
